export default __webpack_public_path__ + "static/media/employer-selected.bdf17460.svg";